var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lang-wrap",on:{"click":function($event){return _vm.$router.push('/Language')}}},[_c('img',{staticClass:"lang-img",attrs:{"src":_vm.languageIcon,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }